import { render, staticRenderFns } from "./medicalRecord.vue?vue&type=template&id=5afe01b6&"
import script from "./medicalRecord.vue?vue&type=script&lang=js&"
export * from "./medicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports